import React, {useState} from "react";
import {observer} from "mobx-react-lite";
import {useTranslation} from "react-i18next";
import {Radio} from "antd";
import CourierIncreaseRequest from "./CourierIncreaseRequest";
import CourierDecreaseRequest from "./CourierDecreaseRequest";
import {
    SupportRequestContainer,
    RequestTypeSelection,
    RequestTypeLabel
} from "../style/CustomerRequestsPage.styles";

const CourierPlanningRequestTab = ({
    tableData,
    tableLoading,
    refetchTable,
    onPaginationChange,
    filters,
    handleUpdateFilters
}) => {
    const {t} = useTranslation();
    const [requestType, setRequestType] = useState("increase"); // increase or decrease

    return (
        <SupportRequestContainer>
            <RequestTypeSelection>
                <RequestTypeLabel>
                    {t("screens.customerRequests.requestTypeSelection")}
                </RequestTypeLabel>
                <Radio.Group onChange={e => setRequestType(e.target.value)} value={requestType}>
                    <Radio value="increase">
                        {t("screens.customerRequests.courierIncreaseRequest")}
                    </Radio>
                    <Radio value="decrease">
                        {t("screens.customerRequests.courierDecreaseRequest")}
                    </Radio>
                </Radio.Group>
            </RequestTypeSelection>

            {requestType === "increase" ? (
                <CourierIncreaseRequest
                    key="increase"
                    tableData={tableData}
                    tableLoading={tableLoading}
                    refetchTable={refetchTable}
                    onPaginationChange={onPaginationChange}
                    filters={filters}
                    handleUpdateFilters={handleUpdateFilters}
                />
            ) : (
                <CourierDecreaseRequest
                    key="decrease"
                    tableData={tableData}
                    tableLoading={tableLoading}
                    refetchTable={refetchTable}
                    onPaginationChange={onPaginationChange}
                    filters={filters}
                    handleUpdateFilters={handleUpdateFilters}
                />
            )}
        </SupportRequestContainer>
    );
};

export default observer(CourierPlanningRequestTab);
